import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import Grid from '@mui/material/Grid2';
import { styled } from "@mui/material";
import React, { useContext } from "react";
import DeviceCard from "../components/Card/DeviceCard";
import { Device } from "@services/devices/types";

const GridCardContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  maxHeight: "100%",
  maxWidth: "100%",
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1.25),
  paddingBottom: theme.spacing(2),
  overflow: "auto",
}));

const DeviceView = ({ deviceId }: { deviceId: Device["id"] }) => {
  const context = useContext(RoomsRealtimeContext);
  const meeting = { ...context.detail?.meeting };

  const participant =
    meeting.participants?.find(({ device }) => device?.id === deviceId) ?? {};

  return (
    <GridCardContainer key={participant?.id}>
      {participant && <DeviceCard participant={participant} />}
    </GridCardContainer>
  );
};

export default DeviceView;
